import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=06d4bc3d&scoped=true&"
import script from "./RegisterForm.vue?vue&type=script&lang=js&"
export * from "./RegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./auth-form.css?vue&type=style&index=0&id=06d4bc3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d4bc3d",
  null
  
)

export default component.exports